// This file is automatically generated. Do not edit manually.

import { ObjectAttribute } from "src/api/generated/erp/db/types/tables/objectAttribute";
import { ConfigurationManualEditContext } from "src/api/generated/erp/configurator/manualEdit/configurationManualEditContext";
import { ObjectAttributeField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeField";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationAttributesApi {
	export async function getPartConfigurationAttributes(args: {
		partConfigurationId: number;
	}): Promise<PartConfigurationAttributesApi_PartConfigurationAttributes> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/attributes/getPartConfigurationAttributes",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as PartConfigurationAttributesApi_PartConfigurationAttributes;
	}

	export async function saveAttributes(args: {
		partConfigurationId: number;
		attributes: Array<ObjectAttribute>;
		manualEditContext?: ConfigurationManualEditContext | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/attributes/saveAttributes",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
				attributes: args.attributes,
				manualEditContext: args.manualEditContext,
			},
		});
		return response as void;
	}

	export async function updateAttributeValueOfConfigurations(args: {
		configurationIds: Array<number>;
		attributeFieldId: number;
		newValue: string | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/attributes/updateAttributeValueOfConfigurations",
			method: "POST",
			data: {
				configurationIds: args.configurationIds,
				attributeFieldId: args.attributeFieldId,
				newValue: args.newValue,
			},
		});
		return response as void;
	}

	export async function getSharedAttributeFieldsOfConfigurations(args: {
		configurationIds: Array<number>;
	}): Promise<Array<ObjectAttributeField>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/attributes/getSharedAttributeFieldsOfConfigurations",
			method: "POST",
			data: {
				configurationIds: args.configurationIds,
			},
		});
		return response as Array<ObjectAttributeField>;
	}
}

export interface PartConfigurationAttributesApi_PartConfigurationAttributes {
	attributeFields: Array<ObjectAttributeField>;
	attributes: Array<ObjectAttribute>;
}
